export default "__VITE_ASSET__NHJ6QB3ZVMf35ip30RyL0A__"